import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


const TaxesReportForm = () => {
  const [formData, setFormData] = useState({
    dateType: 'invoice',
    startDate: '2024-09-01',
    endDate: '2024-09-30',
    includeReferences: false,
    excludeClosedPractices: false,
    format: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
  };

  return (
    <Container className="mt-4" style={{ maxWidth: '600px',marginLeft:"0px" }}>
      <Form onSubmit={handleSubmit} className="p-4 border rounded">
        <fieldset>
          <legend>Parameters</legend>

          {/* Date Type Selection */}
          <Form.Group as={Row} controlId="dateType" className="mb-3">
            <Form.Label column sm="4" title="Please choose a date type">
              Date Type <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="dateType"
                value={formData.dateType}
                onChange={handleChange}
                className="form-select"
                title="Please choose a date type"
                required
              >
                <option value="invoice">Invoice Date</option>
                <option value="payment">Payment Date</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Start Date */}
          <Form.Group as={Row} controlId="startDate" className="mb-3">
            <Form.Label column sm="4" title="Please choose a start date to report on">
              Start Date <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                type="date"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
                required
              />
            </Col>
          </Form.Group>

          {/* End Date */}
          <Form.Group as={Row} controlId="endDate" className="mb-3">
            <Form.Label column sm="4" title="Please choose an end date to report on">
              End Date <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                type="date"
                name="endDate"
                value={formData.endDate}
                onChange={handleChange}
                required
              />
            </Col>
          </Form.Group>

          {/* Include References Checkbox */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="4">&nbsp;</Form.Label>
            <Col sm="8">
              <Form.Check
                type="checkbox"
                name="includeReferences"
                checked={formData.includeReferences}
                onChange={handleChange}
                label="Include references?"
                style={{ marginLeft: 0 }}
              />
            </Col>
          </Form.Group>

          {/* Exclude Closed Practices Checkbox */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="4">&nbsp;</Form.Label>
            <Col sm="8">
              <Form.Check
                type="checkbox"
                name="excludeClosedPractices"
                checked={formData.excludeClosedPractices}
                onChange={handleChange}
                label="Exclude closed practices?"
                style={{ marginLeft: 0 }}
              />
            </Col>
          </Form.Group>

          {/* Format Selection */}
          <Form.Group as={Row} controlId="format" className="mb-3">
            <Form.Label column sm="4" title="Please choose a display format">
              Format <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="format"
                value={formData.format}
                onChange={handleChange}
                className="form-select"
                title="Please choose a display format"
                required
              >
                <option value="">On Screen</option>
                <option value="csv">CSV (Excel)</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Submit Button */}
          <Form.Group as={Row}>
                   <Col sm={{ span: 8, offset: 4 }}>
                       <Link to="/Addtaxes">
                         <Button
                           id="pay-per-task-submit"
                           type="button"
                           variant="primary"
                           className="w-100 mt-2"
                           style={{
                             backgroundColor: '#004aad',
                             borderColor: '#004aad',
                             marginTop: '10px',
                           }}
                         >
                           Run
                         </Button>
                       </Link>
                     </Col>
                   </Form.Group>
        </fieldset>
      </Form>
    </Container>
  );
};

export default TaxesReportForm;
